import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    game_category_list: []
  };
  
  const gameCategoryStateSlice = createSlice({
    name: 'game_category',
    initialState: initialState,
    reducers: {
      listGameCategory: (state, action) => {
        state.game_category_list= action.payload 
      }
    }
  });
  
  export const { listGameCategory } = gameCategoryStateSlice.actions;
  
  export default gameCategoryStateSlice.reducer;